import React from "react"
import { Box } from "@mui/material"
import { ARIA_LABELS } from "@/shared/components/image-gallery/constants"

interface ProgressIndicatorProps {
  total: number
  currentIndex: number
  onSelect: (index: number) => void
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ total, currentIndex, onSelect }) => {
  if (total <= 1) return null

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 16,
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        alignItems: "center",
        gap: 0.5
      }}>
      {Array.from({ length: total }).map((_, idx) => (
        <Box
          key={idx}
          role="button"
          tabIndex={0}
          aria-label={ARIA_LABELS.progressDot(idx)}
          aria-pressed={idx === currentIndex}
          onClick={() => onSelect(idx)}
          onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault()
              onSelect(idx)
            }
          }}
          sx={{
            width: idx === currentIndex ? 24 : 6,
            height: 4,
            borderRadius: 2,
            bgcolor: idx === currentIndex ? "rgba(80,80,80,0.85)" : "rgba(80,80,80,0.35)",
            cursor: "pointer",
            transition: "width 0.25s, background-color 0.25s"
          }}
        />
      ))}
    </Box>
  )
}

export default ProgressIndicator
